export default __webpack_public_path__ + "static/media/webHook_grey.cdd87cb1.svg";